import repository from './repository'

const resource = 'voucher-paid-bies'

export default {
  index(params) {
    return repository.get(resource, { params })
  },
}
